import React from "react";

interface ConditionalRenderProps {
  condition: boolean;
  children: React.ReactElement | React.ReactElement[];
  component: React.ReactNode;
}

const ConditionalRender: React.FunctionComponent<ConditionalRenderProps> = ({
  condition,
  children,
  component,
}) => (
  <>
    {condition && component}
    {!condition && children}
  </>
);

export default ConditionalRender;
